import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { InitPasswordFormSchema, InitPasswordMutation } from './InitPasswordForm.types';
import { getInitPasswordForm } from './InitPasswordForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { INIT_PASSWORD_QUERY_KEY, initPasswordQuery } from './InitPasswordForm.query';
import { registerSignUpStepData } from './InitPasswordForm.data';
import { useNavigate, useParams } from 'react-router-dom';
import Form from '../../../../commons/Form/Form';
import { useEffect, useState } from 'react';
import InitPasswordModal from '../InitPasswordModal/InitPasswordModal';
import { useCommercialEmail } from '../../../../../hooks/fetchers/useCommercialEmail/useCommercialEmail';

export default () => {
  const { commercialId, hash } = useParams();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const [isModalOpen, setModalOpen] = useState(false);

  if (!commercialId) {
    navigate('/login/commercial');
    return <></>;
  }

  const { data: commercial } = useCommercialEmail(parseInt(commercialId));

  const formProps = useForm<InitPasswordFormSchema>({
    resolver: yupResolver(getInitPasswordForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      email: commercial?.email,
    },
  });

  const { handleSubmit, setValue } = formProps;

  useEffect(() => {
    if (commercial) {
      setValue('email', commercial.email);
    }
  }, [commercial]);

  const { mutate } = useMutation<
    Awaited<ReturnType<InitPasswordMutation>>,
    Error,
    InitPasswordFormSchema
  >(
    (data) =>
      initPasswordQuery({ ...data, commercialId: parseInt(commercialId), hash: hash as string }),
    {
      mutationKey: INIT_PASSWORD_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ success }) => {
        if (success) {
          setModalOpen(true);
        }
      },
      onError: async (error) => alert(error.message),
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<InitPasswordFormSchema> data={registerSignUpStepData} {...{ formProps, onSubmit }} />
      <InitPasswordModal isOpen={isModalOpen} setOpen={setModalOpen} />
    </>
  );
};
